(() => {
    (function ($) {
        $(document).ready(function () {

        // GLOBAL VARIABLES
        const moneyFormat = (typeof Shopify !== 'undefined' && Shopify.money_format) ? Shopify.money_format : '${{amount}}'
        console.log('Product Card 2025 loaded - Money format:', moneyFormat)

        // Logger method for debugging V2 cards
        function logDebug(message, data = null) {
            const timestamp = new Date().toLocaleTimeString();
            console.log(`[${timestamp}] V2 Card Debug:`, message, data || '');
        }

        /**
         * Get tier config from element or page global
         * @param {jQuery} $el - Element to check for data-tier-config
         * @returns {string|null} - Tier config ID or null
         */
        function getTierConfig($el) {
            return $el.attr('data-tier-config') || window.TIERED_CART_ACTIVE_CONFIG || null;
        }

        /**
         * Build cart properties for BF products/bundles
         * @param {string} type - 'product' or 'bundle'
         * @param {string|null} tierConfig - Tier config ID
         * @returns {object} - Properties object for cart
         */
        function buildBfProperties(type, tierConfig, $el) {
            const properties = { _bf_product: 'true' };
            if (tierConfig) {
                properties._tier_config = tierConfig;
            }
            const packs = $el && $el.attr('data-packs');
            if (packs && parseInt(packs) > 0) {
                properties._packs = packs;
            }
            return properties;
        }

        // Money formatting function (inline, same as LPV2)
        function formatMoney(cents, format) {
            if (typeof cents == "string") {
                cents = cents.replace(".", "");
            }
            var value = "";
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || moneyFormat || '${{amount}}');

            function defaultOption(opt, def) {
                return typeof opt == "undefined" ? def : opt;
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ",");
                decimal = defaultOption(decimal, ".");
                if (isNaN(number) || number == null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                var parts = number.split("."),
                    dollars = parts[0].replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        "$1" + thousands
                    ),
                    cents = parts[1] ? decimal + parts[1] : "";
                return dollars + cents;
            }

            // Check if format string matches expected pattern
            var match = formatString.match(placeholderRegex);
            if (!match) {
                // Fallback to simple formatting (silently, no error)
                return '$' + formatWithDelimiters(cents, 2);
            }

            switch (match[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);
                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        }

        // Black Friday Pack Pricing Currency Conversion
        function applyBFPackPricing($card) {
            // Skip if already converted
            if ($card.attr('data-bf-converted') === 'true') {
                console.log('BF Pricing - Already converted, skipping');
                return;
            }

            const bfPackUSD = {
                pack1: parseInt($card.attr('data-bf-pack-1-usd')) || 0,
                pack2: parseInt($card.attr('data-bf-pack-2-usd')) || 0,
                pack3: parseInt($card.attr('data-bf-pack-3-usd')) || 0,
                pack4: parseInt($card.attr('data-bf-pack-4-usd')) || 0
            };

            // Check if BF pack pricing is enabled
            if (!bfPackUSD.pack1) return;

            // compare_at values from Liquid are ALREADY in local currency (Shopify Markets handles conversion)
            // So we do NOT convert them - only convert the bf_pack_*_usd values
            const compareAtLocal = {
                pack1: parseInt($card.attr('data-compare-at-pack-1')) || 0,
                pack2: parseInt($card.attr('data-compare-at-pack-2')) || 0,
                pack3: parseInt($card.attr('data-compare-at-pack-3')) || 0,
                pack4: parseInt($card.attr('data-compare-at-pack-4')) || 0
            };

            // Use Shopify's currency rate ONLY for bf_pack_*_usd (which are hardcoded USD cents)
            const currencyRate = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1.0;
            const cardMoneyFormat = $card.data('money-format') || moneyFormat || '${{amount}}';

            // Convert BF prices from USD to local currency, but keep compareAt as-is (already local)
            const converted = {
                pack1: { price: Math.round(bfPackUSD.pack1 * currencyRate), compareAt: compareAtLocal.pack1 },
                pack2: { price: Math.round(bfPackUSD.pack2 * currencyRate), compareAt: compareAtLocal.pack2 },
                pack3: { price: Math.round(bfPackUSD.pack3 * currencyRate), compareAt: compareAtLocal.pack3 },
                pack4: { price: Math.round(bfPackUSD.pack4 * currencyRate), compareAt: compareAtLocal.pack4 }
            };

            // Store converted values back to data attributes
            $card.attr('data-bf-pack-1', converted.pack1.price);
            $card.attr('data-bf-pack-2', converted.pack2.price);
            $card.attr('data-bf-pack-3', converted.pack3.price);
            $card.attr('data-bf-pack-4', converted.pack4.price);
            $card.attr('data-compare-at-pack-1', converted.pack1.compareAt);
            $card.attr('data-compare-at-pack-2', converted.pack2.compareAt);
            $card.attr('data-compare-at-pack-3', converted.pack3.compareAt);
            $card.attr('data-compare-at-pack-4', converted.pack4.compareAt);

            // Mark as converted
            $card.attr('data-bf-converted', 'true');

            console.log('BF Pack Pricing - Currency Rate:', currencyRate, 'Converted:', converted);

            // Check if this is a V2 card
            const isV2Card = $card.hasClass('product-card-v2');

            if (isV2Card) {
                // V2 Card: Update all variant buttons
                let activePackNum = 3;
                $card.find('.pack-variants li').each(function() {
                    const $variantLi = $(this);
                    const variantTitle = $variantLi.find('.variant-title').text().toLowerCase();

                    // Detect pack number
                    let packNum = 1;
                    if (variantTitle.includes('4')) packNum = 4;
                    else if (variantTitle.includes('3')) packNum = 3;
                    else if (variantTitle.includes('2')) packNum = 2;
                    else if (variantTitle.includes('1')) packNum = 1;

                    if ($variantLi.hasClass('active')) activePackNum = packNum;

                    const packData = converted[`pack${packNum}`];
                    if (packData.price > 0) {
                        // Update data attributes with converted values
                        $variantLi.attr('data-price', packData.price);
                        $variantLi.attr('data-compare-price', packData.compareAt);

                        // Update displayed price
                        $variantLi.find('.variant-discounted-price').text(formatMoney(packData.price, cardMoneyFormat));

                        // Calculate and update per-variant percentage
                        if (packData.compareAt > 0) {
                            const variantPercentOff = Math.round(((packData.compareAt - packData.price) / packData.compareAt) * 100);
                            $variantLi.find('.variant-percentage-off-price').text('-' + variantPercentOff + '%');
                        }
                    }
                });

                // Update header badges for active variant
                const activeData = converted[`pack${activePackNum}`];
                if (activeData.price > 0 && activeData.compareAt > 0) {
                    const percentOff = Math.round(((activeData.compareAt - activeData.price) / activeData.compareAt) * 100);
                    const saveAmount = formatMoney(activeData.compareAt - activeData.price, cardMoneyFormat);

                    $card.find('.percent-off-free-gift .percent-off').text(percentOff + '% off');
                    $card.find('.price-off span').text('Save up to ' + saveAmount);

                    console.log(`V2 Card - Badges: ${percentOff}% off, Save ${saveAmount}`);
                }
            } else {
                // V1 Card: Default to pack 1
                const packData = converted.pack1;

                if (packData.price > 0) {
                    // Update displayed price
                    const formattedPrice = formatMoney(packData.price, cardMoneyFormat);
                    $card.find('.price-details .discounted-price').text(formattedPrice);
                    $card.attr('data-discounted-price', formattedPrice);
                    $card.attr('data-discounted-price-no-currency', packData.price);

                    // Calculate and update badges
                    if (packData.compareAt > 0) {
                        const percentOff = Math.round(((packData.compareAt - packData.price) / packData.compareAt) * 100);
                        const saveAmount = formatMoney(packData.compareAt - packData.price, cardMoneyFormat);

                        $card.find('.percent-off-free-gift .percent-off').text(percentOff + '% OFF');
                        $card.find('.price-off span').text('Save ' + saveAmount);

                        console.log(`V1 Card - Badges: ${percentOff}% off, Save ${saveAmount}`);
                    }
                }
            }
        }

        // Wait for currency to be ready, then initialize BF Pack Pricing
        function initializeBFPricing() {
            $('.product-card[data-bf-pack-1-usd], .product-card-v2[data-bf-pack-1-usd]').each(function() {
                applyBFPackPricing($(this));
            });
        }

        // Initialize BF pricing - Shopify.currency.rate should be available by document.ready
        initializeBFPricing();

        // Random products slick
        $.fn.randomize = function (selector) {
            var $elems = selector ? $(this).find(selector) : $(this).children(),
            $parents = $elems.parent();

            $parents.each(function () {
                $(this).children(selector).sort(function (childA, childB) {
                    // * Prevent last slide from being reordered
                    if($(childB).index() !== $(this).children(selector).length - 1) {
                        return Math.round(Math.random()) - 0.5;
                    }
                }.bind(this)).detach().appendTo(this);
            });

            return this;
        };

        // Function to initialize "You may also like" slider
        function initializeAlsoLikeSlider($slider) {
            if (!$slider.hasClass('slick-initialized')) {
                $slider.randomize().slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 10000, // 10 seconds
                    arrows: false,
                    dots: false,
                    speed: 500,
                    fade: true,
                    cssEase: 'linear',
                    infinite: true,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    speed: 800
                });
            }
        }

        // CART BUBBLE 
                function updateCartBubbleFromServer() {
          $.getJSON('/cart.js').done(function(cart){
              updateCartBubble(cart.item_count || 0);
          }).fail(function(){
              console.warn('Unable to fetch cart.js to update badge.');
          });
        }

        function updateCartBubble(count) {
            const $icon = $('#cart-icon-bubble');

            if (!$icon.length) return;

            let $bubble = $icon.find('.cart-count-bubble');

            if (!$bubble.length) {
                $bubble = $(`
                <div class="cart-count-bubble">
                    <span aria-hidden="true"></span>
                    <span class="visually-hidden"></span>
                </div>
                `);
                $icon.append($bubble);
            }

            $bubble.find('span[aria-hidden="true"]').text(count);
            $bubble.find('.visually-hidden').text(count + (count === 1 ? " item" : " items"));

            if (count > 0) {
                $bubble.show();
                $bubble.addClass('cart-bubble-update');
                setTimeout(() => $bubble.removeClass('cart-bubble-update'), 600);
            } else {
                $bubble.hide();
            }
        }

        // Don't initialize sliders on page load - wait until they're needed

        const getElementByParent = (targetEl, childEl) => {
            return targetEl.closest('.product-card').find(childEl)
        }

        // Open options
        $('.choose-options-btn').on('click', function () {
            const optionsContainer = getElementByParent($(this), '.product-card-options');
            const cardContainer = getElementByParent($(this), '.product-card-box');
            const productCardContainer = $(this).closest('.product-card')

            optionsContainer.removeClass('bf-2025--hidden');
            cardContainer.addClass('bf-2025--hidden');
            productCardContainer.addClass('active');

            // Apply default subscribe & pack settings if configured
            const defaultSubscribe = productCardContainer.attr('data-default-subscribe') === 'true';
            const defaultPack = parseInt(productCardContainer.attr('data-default-pack')) || 1;

            if (defaultSubscribe) {
                // Select Subscribe & Save radio
                const subscribeRadio = productCardContainer.find('input[value="subscribe_save"]');
                if (subscribeRadio.length && !subscribeRadio.prop('checked')) {
                    subscribeRadio.prop('checked', true).trigger('change');
                }

                // Select the default pack (0-indexed: pack 1 = index 0, pack 2 = index 1, pack 3 = index 2)
                const packIndex = Math.min(Math.max(defaultPack - 1, 0), 2); // Clamp to 0-2
                const packBtn = productCardContainer.find('.select-more-pack-btns button').eq(packIndex);
                if (packBtn.length && !packBtn.hasClass('active')) {
                    packBtn.trigger('click');
                }
            }

            // Initialize or refresh Slick slider after container becomes visible
            setTimeout(function() {
                const slider = optionsContainer.find('.also-like-slider');
                if (slider.length) {
                    if (slider.hasClass('slick-initialized')) {
                        // Refresh if already initialized
                        slider.slick('setPosition');
                    } else {
                        // Initialize if not yet initialized
                        initializeAlsoLikeSlider(slider);
                    }
                }
            }, 50);
        });

        // Close options
        $('.close-options-btn').on('click', function () {
            const optionsContainer = getElementByParent($(this), '.product-card-options');
            const cardContainer = getElementByParent($(this), '.product-card-box');
            const productCardContainer = $(this).closest('.product-card')

            optionsContainer.addClass('bf-2025--hidden');
            cardContainer.removeClass('bf-2025--hidden');
            productCardContainer.removeClass('active');
        });

        // Choose pack - handled inside .product-card.each() to access getProduct function

        // Shopify formatMoney helper
        // Note: Removed "if (typeof Shopify === 'undefined') { var Shopify = {}; }"
        // because it creates an empty Shopify object before the real one loads
        if (typeof Shopify.formatMoney === 'undefined') {
          Shopify.formatMoney = function(cents, format) {
          if (typeof cents == 'string') {
          cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || this.money_format);
          function defaultOption(opt, def) {
              return (typeof opt == 'undefined' ? def : opt);
          }
          function formatWithDelimiters(number, precision, thousands, decimal) {
              precision = defaultOption(precision, 2);
              thousands = defaultOption(thousands, ',');
              decimal = defaultOption(decimal, '.');
              if (isNaN(number) || number == null) {
                  return 0;
              }
              number = (number / 100.0).toFixed(precision);
              var parts = number.split('.'),
                  dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                  cents = parts[1] ? (decimal + parts[1]) : '';
              return dollars + cents;
          }
          switch (formatString.match(placeholderRegex)[1]) {
              case 'amount':
                  value = formatWithDelimiters(cents, 2);
                  break;
              case 'amount_no_decimals':
                  value = formatWithDelimiters(cents, 0);
                  break;
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters(cents, 2, '.', ',');
                  break;
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters(cents, 0, '.', ',');
                  break;
          }
          return formatString.replace(placeholderRegex, value);
        };
        }

        // Add to cart function
        async function addToCart(products, redirectToCheckout = false, parentEl, targetEl, buttonDefaultText) {
            targetEl.html('Adding...')
            targetEl.css({
                "cursor": "unset",
                "pointer-events": "none",
                "opacity": "0.7"
            })
            parentEl.find('.added-to-cart-message').addClass('bf-2025--hidden');
            try {
                 const pathParts = window.location.pathname.split('/');
                const firstSegment = pathParts[1];

                const hasLocale = firstSegment && firstSegment.includes('-');
                const localePrefix = hasLocale ? `/${firstSegment}` : ''; // e.g. "/en-ph" or ""

                const items = Array.isArray(products) ? products : [products];
                const payload = {
                    items: items.map(item => {
                        let data = {
                            id: item.variantId,
                            quantity: item.quantity || 1
                        };
                        if (item.planId) {
                            data.selling_plan = item.planId; // Only add if subscription
                        }
                        if (item.properties) {
                            data.properties = item.properties; // Add properties if provided
                        }
                        return data;
                    })
                };

                // Add to cart
                const response = await fetch(`/cart/add.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                const data = await response.json();
                console.log("✅ Added to cart:", data);

                // Trigger iCart slideout to open
                if (typeof window.prepareDataForDisplayWidgetByRule === 'function') {
                    window.prepareDataForDisplayWidgetByRule();
                }

                if (redirectToCheckout) {
                    window.location.href = '/checkout';
                }

                parentEl.find('.added-to-cart-message').removeClass('bf-2025--hidden');
                setTimeout(() => {
                  parentEl.find('.added-to-cart-message').addClass('bf-2025--hidden');
                }, 5000)
                parentEl.find('.checkout-btn').removeClass('bf-2025--disabled');

                if ( targetEl.hasClass('add-pet-locket') ) {
                    const $slide = targetEl.closest('.slick-slide');
                    var $slider = $slide.closest('.also-like-slider');
                      // Re-fetch Slick instance and current slide index dynamically
                    const slickInstance = $slider.slick('getSlick');
                    const index = $slide.data('slick-index');
                    $slide.addClass('removing');
                    setTimeout(function () {
                        $slider.slick('slickRemove', index);
                        $slider.slick('refresh');
                        const updatedSlick = $slider.slick('getSlick');
                        updatedSlick.$slides.each(function (i) {
                            $(this).attr('data-slick-index', i);
                        });
                            if (updatedSlick.slideCount <= 1) {
                                $slider.slick('unslick');
                                $slider.remove();
                            }
                    }, 400);
                 }


                  if (typeof updateCartBubbleFromServer === 'function') {
                        updateCartBubbleFromServer();
                    }
                return data;
            } catch (err) {
                console.error("❌ Error adding to cart:", err);
            } finally {
               targetEl.html(buttonDefaultText)
                targetEl.css({
                    "cursor": "pointer",
                    "pointer-events": "all",
                    "opacity": "1"
                })
            }
        }

        // Add related product to cart
        $('.add-pet-locket').on('click',  function() {
          const parentEl = $(this).closest('.product-card');
          const variantId = $(this).closest('.pet-locket-cta').attr('data-petlocket-id');
          const quantity = $(this).closest('.pet-locket-cta').find('.bf-2025--quantity').attr('data-quantity')

           const products = [
                {
                    variantId: +variantId,
                    quantity: +quantity,
                }
            ];
          addToCart(products, false, parentEl, $(this), 'Add');
        })

        // Add main product to cart
        $('.add-to-cart-btn').on('click', function() {
          const parentEl = $(this).closest('.product-card');
          const variantId = parentEl.attr('data-variant-id');
          // For pack products, the "quantity" UI represents which pack variant is selected, not cart quantity
          // Always add quantity 1 of the selected pack variant
          const quantity = 1;
          const purchaseType = parentEl.attr('data-purchase-type')
          const planId = parentEl.find('input[name="selling_plan"]')
          const isBfProduct = parentEl.attr('data-bf-product') === 'true';

          const product = {
              variantId: +variantId,
              quantity: quantity,
              planId: purchaseType === "subscribe_save" ? +planId.val() : null
          };

          if (isBfProduct) {
              product.properties = buildBfProperties('product', getTierConfig(parentEl), parentEl);
          }

          const products = [product];
          addToCart(products, false, parentEl, $(this), "Add to cart");
        })

        // Product card functionality
        $('.product-card').each(function() {
            let $card = $(this);
            let $qtyWrapper = $card.find('.add-to-cart .bf-2025--quantity');
            let $valueEl = $qtyWrapper.find('.value');
            let $plusBtn = $qtyWrapper.find('.plus');
            let $minusBtn = $qtyWrapper.find('.minus');
            let $totalEl = $card.find('.checkout .discounted-price');
            let $purchaseTypeRadios = $card.find('.cta-purchase-type input[type="radio"]');
            let $sellingPlanInput = $card.find('input[name="selling_plan"]');
            let $preselectPlan = $card.data('preselect-plan');
            let $productHandle = $card.data('handle');
            let $discountOverride = parseFloat($card.data('discount-override')) || 1;

            let $secondProdqtyWrapper = $card.find('.pet-locket-quantity .bf-2025--quantity');

            let moneyFormat = $card.data('money-format');
            let qty = parseInt($qtyWrapper.data('quantity'), 10);
            let subscribeDiscount = parseFloat($card.data('subscribe-discount')) || 0.85;

            // Subscription frequency dropdown
            let $subscriptionDropdown = $card.find('.subscription-frequency-select');
            let $subscriptionWrapper = $card.find('.subscription-frequency-wrapper');
            let sellingPlansRaw = $card.attr('data-selling-plans') || '[]';
            let sellingPlansData = [];
            try {
                sellingPlansData = JSON.parse(sellingPlansRaw);
            } catch (e) {
                console.warn('Could not parse selling plans data:', e);
            }

            // set default purchase type
            let purchaseType = $card.attr('data-purchase-type') || 'one_time';

            // Initialize subscription dropdown for the initial variant
            (function initSubscriptionDropdown() {
                const initialVariantId = $card.attr('data-variant-id');
                if (!sellingPlansData || !sellingPlansData.length) return;

                const variantPlans = sellingPlansData.filter(p => p.variant_id == initialVariantId);

                if (variantPlans.length === 0) {
                    // Initial variant has no selling plans - hide subscription option
                    $card.find('input[value="subscribe_save"]').closest('.custom-radio').hide();
                    return;
                }

                // Populate dropdown with initial variant's plans
                let options = '';
                variantPlans.forEach(plan => {
                    const isDefault = plan.name.toLowerCase().includes('7 weeks');
                    options += `<option value="${plan.id}"${isDefault ? ' selected' : ''}>${plan.name}${isDefault ? ' (most common)' : ''}</option>`;
                });
                $subscriptionDropdown.html(options);
            })();

            // Handle radio button (purchase type change)
            $purchaseTypeRadios.on('change', function() {
                purchaseType = $(this).val();
                $card.attr('data-purchase-type', purchaseType);

                if (purchaseType === 'subscribe_save') {
                    // Show dropdown and use its value (or fallback to preselect)
                    $subscriptionWrapper.removeClass('bf-2025--hidden');
                    $sellingPlanInput.val($subscriptionDropdown.val() || $preselectPlan);
                } else {
                    // Hide dropdown and clear selling plan
                    $subscriptionWrapper.addClass('bf-2025--hidden');
                    $sellingPlanInput.val('');
                }

                console.log('Selling plan:', $sellingPlanInput.val());
                // Re-fetch product with current quantity to update prices for the new purchase type
                getProduct($productHandle, $card, qty);
            });

            // Handle subscription frequency dropdown change
            $subscriptionDropdown.on('change', function() {
                const selectedPlanId = $(this).val();
                $sellingPlanInput.val(selectedPlanId);
                console.log('Subscription frequency changed to:', selectedPlanId);
            });

            let controller;
          async function getProduct(handle, card, packNumber) {
                if (controller) controller.abort();
                controller = new AbortController();
                try {
                    const response = await fetch(`/products/${handle}.js`, {
                        signal: controller.signal,
                     })
                    const data = await response.json();
                    console.log(data)

                    const variants = data.variants;
                    if(variants.length === 4){
                        const filteredVariant = variants.filter((variant) => variant.title.includes(`${packNumber}`))
                        const cardMoneyFormat = card.data('money-format') || moneyFormat || '${{amount}}';
                        const currentPurchaseType = card.attr('data-purchase-type') || 'one_time';

                        let rawOriginalPrice, rawDiscountedPrice;

                        // Use already-converted data attributes if BF converted
                        if (card.attr('data-bf-converted') === 'true') {
                            rawDiscountedPrice = parseInt(card.attr('data-bf-pack-' + packNumber)) || 0;
                            rawOriginalPrice = parseInt(card.attr('data-compare-at-pack-' + packNumber)) || 0;
                            console.log(`V1 Card - Using converted pack ${packNumber}: price=${rawDiscountedPrice}, compareAt=${rawOriginalPrice}`);
                        } else {
                            // Fallback to API values with discount override
                            rawOriginalPrice = filteredVariant[0].compare_at_price;
                            rawDiscountedPrice = Math.round(filteredVariant[0].price * $discountOverride);
                        }

                        // Apply subscription discount if in subscribe_save mode
                        if (currentPurchaseType === 'subscribe_save') {
                            rawOriginalPrice = Math.round(rawOriginalPrice * subscribeDiscount);
                            rawDiscountedPrice = Math.round(rawDiscountedPrice * subscribeDiscount);
                            console.log(`V1 Card - Applied subscription discount (${subscribeDiscount}): price=${rawDiscountedPrice}, compareAt=${rawOriginalPrice}`);
                        }

                        const orignalPrice = Shopify.formatMoney(rawOriginalPrice, cardMoneyFormat)
                        const discountedPrice = Shopify.formatMoney(rawDiscountedPrice, cardMoneyFormat)

                        let percentOff = 0;
                        if (rawOriginalPrice > 0 && rawDiscountedPrice > 0) {
                            percentOff = Math.round(((rawOriginalPrice - rawDiscountedPrice) / rawOriginalPrice) * 100);
                        }

                        const saveAmount = Shopify.formatMoney(rawOriginalPrice - rawDiscountedPrice, cardMoneyFormat);

                        $totalEl.text(discountedPrice);
                        card.attr('data-variant-id', filteredVariant[0].id)
                        // Update subscription dropdown for the new variant
                        updateSubscriptionDropdown(filteredVariant[0].id);
                        card.find('.product-details-cover').attr('src', filteredVariant[0].featured_image.src)
                        card.find('.product-details .product-name').text(filteredVariant[0].name.replace('(BFCM)', ''))
                        card.find('.product-details .original-price').text(orignalPrice)
                        card.find('.product-details .discounted-price').text(discountedPrice)
                        card.find('.product-details .percent-off').text(`${percentOff}% off`)

                        // Also update the main card badges
                        card.find('.percent-off-free-gift .percent-off').text(`${percentOff}% OFF`);
                        card.find('.price-off span').text(`Save ${saveAmount}`);

                        console.log(`V1 getProduct - Pack ${packNumber}: ${percentOff}% off, Save ${saveAmount}`);
                    }else if (variants.length === 1 || variants.length > 4){
                        updateTotal(packNumber);
                    }
                } catch (error) {
                    if (error.name === 'AbortError') console.log('Old request cancelled');
                    else console.error(error);
                }
          }

            // Update total based on current purchase type and quantity
            function updateTotal(qtyArg) {
                // Use passed argument or fall back to closure variable
                const currentQty = qtyArg !== undefined ? qtyArg : qty;
                let basePrice;
                const cardMoneyFormat = $card.data('money-format') || moneyFormat || '${{amount}}';

                // Use already-converted data attributes if BF converted
                if ($card.attr('data-bf-converted') === 'true') {
                    basePrice = parseInt($card.attr('data-bf-pack-' + currentQty)) || 0;
                    console.log(`V1 Card updateTotal - Using converted pack ${currentQty} price: ${basePrice}`);
                    // Apply subscription discount if in subscribe_save mode
                    if (purchaseType === 'subscribe_save') {
                        basePrice = Math.round(basePrice * subscribeDiscount);
                        console.log(`V1 Card updateTotal - Applied subscription discount: ${basePrice}`);
                    }
                } else {
                    // Not a BF product or not converted, use regular pricing
                    if (purchaseType === 'one_time') {
                        basePrice = parseInt($card.data('discounted-price-no-currency'), 10);
                    } else if (purchaseType === 'subscribe_save') {
                        basePrice = parseInt($card.data('discounted-price-subscription-no-currency'), 10);
                    }
                }

                $totalEl.text(Shopify.formatMoney(basePrice, cardMoneyFormat));
                $qtyWrapper.attr('data-quantity', currentQty);
            };

            // Update subscription dropdown when variant changes
            function updateSubscriptionDropdown(variantId) {
                if (!sellingPlansData || !sellingPlansData.length) return;

                const variantPlans = sellingPlansData.filter(p => p.variant_id == variantId);

                if (variantPlans.length === 0) {
                    // This variant has no selling plans - hide subscription option entirely
                    $subscriptionWrapper.addClass('bf-2025--hidden');
                    $card.find('input[value="subscribe_save"]').closest('.custom-radio').hide();
                    // If currently on subscribe mode, switch to one_time
                    if (purchaseType === 'subscribe_save') {
                        $card.find('input[value="one_time"]').prop('checked', true).trigger('change');
                    }
                    return;
                }

                // Show subscription option
                $card.find('input[value="subscribe_save"]').closest('.custom-radio').show();

                // Rebuild dropdown with this variant's plans
                let options = '';
                variantPlans.forEach(plan => {
                    const isDefault = plan.name.toLowerCase().includes('7 weeks');
                    options += `<option value="${plan.id}"${isDefault ? ' selected' : ''}>${plan.name}${isDefault ? ' (most common)' : ''}</option>`;
                });
                $subscriptionDropdown.html(options);

                // Update hidden input if in subscribe mode
                if (purchaseType === 'subscribe_save') {
                    $sellingPlanInput.val($subscriptionDropdown.val());
                }

                console.log('Subscription dropdown updated for variant:', variantId, 'Plans:', variantPlans.length);
            }

            // Quantity controls
            $plusBtn.on('click', function() {
                if(qty <= 3) {
                qty++;
                $valueEl.text(qty);
                getProduct($productHandle, $card, qty)
                }

            });

            $minusBtn.on('click', function() {
                if (qty > 1) {
                qty--;
                $valueEl.text(qty);
                console.log(qty)
                getProduct($productHandle, $card, qty)
                }
            });

            // Related products quantity controls
            $secondProdqtyWrapper.each(function () {
                let controller;
                async function getSecondProduct(handle, card, packNumber) {
                    if (controller) controller.abort();
                    controller = new AbortController();
                    try {
                        const response = await fetch(`/products/${handle}.js`, { signal: controller.signal, })
                        const data = await response.json();
                        console.log(data)
                        const variants = data.variants;
                        if(variants.length === 4){
                            const filteredVariant = variants.filter((variant) => variant.title.includes(`${packNumber}`))

                            const rawOriginalPrice = filteredVariant[0].compare_at_price;
                            const rawDiscountedPrice = Math.round(filteredVariant[0].price * $discountOverride);

                            const cardMoneyFormat = $card.data('money-format') || moneyFormat || '${{amount}}';
                            const orignalPrice = Shopify.formatMoney(rawOriginalPrice, cardMoneyFormat)
                            const discountedPrice = Shopify.formatMoney(rawDiscountedPrice, cardMoneyFormat)
                            card.attr('data-petlocket-id', filteredVariant[0].id)
                            card.find('.pet-locket-details img').attr('src', filteredVariant[0].featured_image.src)
                            card.find('.name').text(filteredVariant[0].name.replace('(BFCM)', ''))

                              card.find('.pet-locket-original-price').text(orignalPrice)
                           card.find('.pet-locket-discounted-price').text(discountedPrice)

                        }else if (variants.length === 1 || variants.length > 4){

                        }
                    } catch (error) {
                        if (error.name === 'AbortError') console.log('Old request cancelled');
                        else console.error(error);
                    }
                }

                const $qty = $(this);
                const card = $(this).closest('.pet-locket-cta')
                const $minus = $qty.find('.minus');
                const $plus = $qty.find('.plus');
                const $value = $qty.find('.value');

                const handle = card.attr('data-handle')

                $minus.on('click', function () {
                    let current = parseInt($value.text());
                    if (current > 1) {
                        $value.text(current - 1);
                         $qty.attr('data-quantity',current - 1)
                         getSecondProduct(handle, card, current - 1)
                    }
                });

                $plus.on('click', function () {
                    let current = parseInt($value.text());
                     if(current <= 3){
                         $value.text(current + 1);
                        $qty.attr('data-quantity', current + 1)
                         getSecondProduct(handle, card, current + 1)
                     }
                });
            });

            // Pack selection buttons (One/Double/Triple)
            $card.find('.select-more-pack-btns button').on('click', function() {
                const $btn = $(this);
                const index = $btn.index(); // 0 = One, 1 = Double, 2 = Triple
                const packNumber = index + 1; // 1, 2, or 3

                // Update active state
                $card.find('.select-more-pack-btns button').removeClass('active');
                $btn.addClass('active');

                // Update quantity display and state
                qty = packNumber;
                $valueEl.text(qty);
                $qtyWrapper.attr('data-quantity', qty);

                // Fetch product and update prices
                getProduct($productHandle, $card, packNumber);
            });

            // initialize total
            updateTotal(qty);
        });

        // Product card v2 (variant selector style)
        $('.product-card-v2').each(function() {
            let $card = $(this);
            let $variantParentEl = $card.find('.pack-variants ul')
            let variant = $card.find('.pack-variants li')
            let $addToCartButton = $card.find('.add-to-cart-v2 button')
            let showMoreBtn = $card.find('.show-more-variants')
            let moneyFormat = $card.data('money-format');

            variant.on('click', function() {
                const clickedVariantId = $(this).attr('data-variant-id');
                const variantTitle = $(this).find('.variant-title').text().trim();

                logDebug('Variant clicked', {
                    variantId: clickedVariantId,
                    title: variantTitle
                });

                variant.removeClass('active')
                $(this).addClass('active')
                $variantParentEl.attr('data-current-id', clickedVariantId);

                logDebug('data-current-id updated to', clickedVariantId);

                // V2: Update percentage off and discount save using already-converted data attributes
                const comparePrice = parseFloat($(this).attr('data-compare-price')) || 0;
                const price = parseFloat($(this).attr('data-price')) || 0;
                const cardMoneyFormat = $card.data('money-format') || moneyFormat || '${{amount}}';

                if (comparePrice > 0 && price > 0) {
                    // Calculate percentage off
                    const percentageOff = Math.round(((comparePrice - price) / comparePrice) * 100);

                    // Calculate save amount (already in local currency if BF converted)
                    const saveAmountFormatted = Shopify.formatMoney(comparePrice - price, cardMoneyFormat);

                    // Update the percentage off display
                    $card.find('.percent-off-free-gift .percent-off').text(percentageOff + '% off');

                    // Update the save amount display
                    $card.find('.price-off span').text('Save up to ' + saveAmountFormatted);

                    logDebug('V2 variant click - Updated displays', {
                        percentageOff: percentageOff + '%',
                        saveAmount: saveAmountFormatted,
                        comparePrice: comparePrice,
                        price: price
                    });
                }
            })

            $addToCartButton.on('click', function() {
               const parentEl = $(this).closest('.product-card-v2');
               let variantId =  $variantParentEl.attr('data-current-id')
               let quantity = 1;
               const isBfProduct = parentEl.attr('data-bf-product') === 'true';
               const tierConfig = getTierConfig(parentEl);

               logDebug('Add to Cart clicked', {
                   variantId: variantId,
                   variantIdType: typeof variantId,
                   activeVariantId: $card.find('.pack-variants li.active').attr('data-variant-id'),
                   activeVariantTitle: $card.find('.pack-variants li.active .variant-title').text().trim(),
                   isBfProduct: isBfProduct,
                   tierConfig: tierConfig
               });

                const product = {
                    variantId: +variantId,
                    quantity: +quantity
                };

                if (isBfProduct) {
                    product.properties = buildBfProperties('product', tierConfig, parentEl);
                }

                const products = [product];

                logDebug('Calling addToCart with products', products);
                addToCart(products, false, parentEl, $(this), 'Add to cart');
            })

             // Show more variants
            showMoreBtn.on('click', function() {
            const $list =  $card.find('.pack-variants ul')
                $list.toggleClass('show-all');

                if ($list.hasClass('show-all')) {
                    $(this).text('Show Less');
                } else {
                    $(this).text('Show More');
                }
            });

        })

        // Sort variants
        $('.pack-variants ul').each(function() {
            const $ul = $(this);
            const $items = $ul.find('li');

            if ($items.length < 3) return;

            logDebug('Before sorting', {
                firstItemId: $items.eq(0).attr('data-variant-id'),
                firstItemTitle: $items.eq(0).find('.variant-title').text().trim(),
                dataCurrent: $ul.attr('data-current-id')
            });

            const $first = $items.eq(0);
            const $third = $items.eq(2);

            $first.insertAfter($third);

            // Update data-current-id to match the currently active variant after sorting
            const $activeVariant = $ul.find('li.active');
            if ($activeVariant.length) {
                const newActiveId = $activeVariant.attr('data-variant-id');
                $ul.attr('data-current-id', newActiveId);

                logDebug('After sorting', {
                    activeVariantId: newActiveId,
                    activeVariantTitle: $activeVariant.find('.variant-title').text().trim(),
                    newFirstItemId: $ul.find('li').eq(0).attr('data-variant-id'),
                    newFirstItemTitle: $ul.find('li').eq(0).find('.variant-title').text().trim()
                });
            }
        });

        // Bundle add to cart (if bundles exist on page)
        $('.bundle-add-to-cart button').each(function() {
            let parentEl = $(this).closest('.slider-bundle-card');

            $(this).on('click', function() {
                let variantId = parentEl.attr('data-id');
                const products = [
                    {
                        variantId: +variantId,
                        quantity: 1,
                        properties: buildBfProperties('bundle', getTierConfig(parentEl), parentEl)
                    }
                ];
                addToCart(products, false, parentEl, $(this), 'Add to cart');
            })
        })

        // Image modal (if modal exists on page)
        $('#imagesModal').on('show.bs.modal', function (event) {
            console.log('Image modal shown');
            let button = $(event.relatedTarget)
            // Support both carousel (.slick-slide) and grid (.grid__item, .product-card) structures
            let card = button.closest('.slick-slide, .grid__item, .product-card')
            let images = card.find('.image-grid-product')

            let modal = $(this)
            if (images.length > 0 && images.get(0)) {
                modal.find('.modal-body').html(images.get(0).outerHTML)
            }
        })

   });
 })(jQuery);
})()
